import { useMutation as e } from "@maat/store-hooks";
import { accountDeletionApi as t } from "@maat/api-main";
//#region src/account-deletion/useRequestAccountDeletionMutation.ts
var n = () => e({ mutationFn: t.requestDeletion });
//#endregion
export { n as useRequestAccountDeletionMutation };
